import { render, staticRenderFns } from "./AttendCompanyView.vue?vue&type=template&id=2210da7d&scoped=true&"
import script from "./AttendCompanyView.vue?vue&type=script&lang=js&"
export * from "./AttendCompanyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210da7d",
  null
  
)

export default component.exports